export const routesName ={
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  LIST_ALL_USERS: '/list-all-users',
  ADD_USER: '/add-user',
  MODIFY_USER: '/modify-user',
  CHANGE_PASSWORD: '/change-password',
  NOT_FOUND: '*',
  BILLING: '/billing',
  LISTBILLIS: '/list-billings',
  EDITBILLING: '/edit-billing',
  BILLING_ITEM: '/billing-item',
  BILLING_PRINT: '/billing-print',
  FINANCIALYEAR: '/financial-year',
  BILLING_CATEGORY: '/billing-category',
  BILLING_EDIT: '/billing-edit/:billingId',
  BILLING_LIST: '/billing-list',
  BILLING_ITEM_EDIT: '/billing-item-edit/:billingItemId',
  BILLING_ITEM_LIST: '/billing-item-list',
  SALES_REPORT: 'report/sales',
  
};  